<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">The Experience elements<br />of F.I.</h1>
        <p id="role">Infographic<br />2015</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />논문주제인 ‘미디어 상호작용 유형을 통한
          플렉서블 아이덴티티 경험요소’ 를 인포그래픽으로 표현하였다. ‘플렉서블
          아이덴티티는 상호작용 유형에 의해 사용자에게 어떤 경험을
          가져오는가?’를 연구문제로 설정하여 사용자 경험 활용의 방향을
          제시하였다. ‘상호작용 유형 매트릭스’를 구성하여 웹 미디어 사례를
          분석한 결과 ‘감각적 경험’에서는 ‘시각적 자극’을, ‘정서적 경험’에서는
          ‘자아관여’를, ‘사고적 경험’에서는 ‘지적욕구’를, ‘행동적 경험’에서는
          ‘반응’을, ‘관계적 경험’에서는 ‘참여’를 경험요소로 활용해야 한다는 점을
          증명하였다.
        </p>
        <p id="name"><b>Planning:</b> Yuri Ahn<br /><b>Design:</b> Yuri Ahn</p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/experience_elements/01.jpg" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('hair-schedule')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('nine-o-clock')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailExperienceElements",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/experience_elements/top.jpg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: 150px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
